export default "__VITE_ASSET__XMJ1nYdX__"